import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BrandGuard } from '@open-portal-app/core/guards/brand.guard';

// components
import { OverviewLandingComponent } from '@open-portal-app/overview/overview-landing/overview-landing.component';

const routes: Routes = [
  {
    path: '',
    component: OverviewLandingComponent,
    pathMatch: 'full',
    data: { pageType: 'overview' },
    resolve: {},
    canActivate: [BrandGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class OverviewRoutingModule { }
